import { render, staticRenderFns } from "./TradeMain.vue?vue&type=template&id=319061c5&lang=pug"
import script from "./TradeMain.vue?vue&type=script&lang=js"
export * from "./TradeMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports